var r={exports:{}};export{r as g};
//# sourceMappingURL=index5.js.map
